

export const Store = () => {

    window.whodunit = {}
    window.whodunit.theme = {}
    window.whodunit.theme.scrollBlock = false ;

    window.whodunit.theme.jobs = {}
    window.whodunit.theme.jobs.searchParams = {} ;

    window.whodunit.theme.blog = {}
    window.whodunit.theme.blog.searchParams = {} ;

    window.whodunit.theme.leaflet = {}
    window.whodunit.theme.leaflet.maps         = {}
    window.whodunit.theme.leaflet.markers      = {}
    window.whodunit.theme.leaflet.markers_data = {}

}